import { z } from 'zod';

/** Validates a well-formed email address. */
export const emailSchema = z.string().email('Invalid email address');

/** Validates a password against the Cognito password policy. */
export const cognitoPasswordSchema = z
  .string()
  .min(8, 'Password must be at least 8 characters')
  .regex(/[A-Z]/, 'Password must contain an uppercase letter')
  .regex(/[a-z]/, 'Password must contain a lowercase letter')
  .regex(/[0-9]/, 'Password must contain a number')
  .regex(/[^A-Za-z0-9]/, 'Password must contain a symbol');

/** Validates the create-user form payload. */
export const createUserSchema = z.object({
  email: emailSchema,
  temporaryPassword: cognitoPasswordSchema,
  role: z.enum(['admin', 'user', 'read-only']),
});
